import React, { useState, useEffect, useRef } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import Datepicker from "react-tailwindcss-datepicker";
import { useNavigate } from "react-router";

import {
  SlSelect,
  SlOption,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import { format, getMonth, getYear, subMonths } from "date-fns";
import { Toast } from "../../shared/Toast";
import { CSVLink } from "react-csv";
import Paginator from "../../shared/Paginator";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { toLakhs, languageOptions, stateOptions, pricePackages, packageNewOldOptions, LocalPricePackages } from "../../utils/constants";
import Select from 'react-select';
import api from "../../services/api";
import { formatDateDDMMYYY } from "../../utils/dateFormat";
import TableSkelton from "../../shared/TableSkelton";

const PackageAdReport = () => {

  const today = new Date();
  const thisMonthStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
  const thisMonthEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const formattedthisMonthStartDate = format(thisMonthStartDate, 'yyyy-MM-dd');
  const formattedthisMonthEndDate = format(thisMonthEndDate, 'yyyy-MM-dd');
  const navigate = useNavigate();

  const [packagedata, setpackagedata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalcount, settotalcount] = useState(0);
  const [packageType, setpackageType] = useState([{value:'Alpha', label:"Alpha Ads"}]);
  const [downloader, setDownloader] = useState(false);
  const [salesList, setsalesList] = useState([]);
  const [salesId, setsalesId] = useState(null);
  const [weeks, setweeks] = useState(null);
  const [package_new_old, setpackage_new_old] = useState(null);
  const csvLinkRef = useRef();
  const [dateRange, setDateRange] = useState({ startDate: formattedthisMonthStartDate, endDate: formattedthisMonthEndDate });
  const [langfilter, setLangFilter] = useState("1");
  const [statefilter, setStatefilter] = useState(-1);
  const [districtselect, setSelectdistrict] = useState([]);
  const [districtfilter, setDistrictfilter] = useState([]);
  const [internalDetails, setInternalDetails] = useState([]);
  const [target_filter, setTarget_filter] = useState({
    lang_id: "1",
    state_id: -1,
    district_id: [],
  });
  const getLanguageLabel = (lang_id) => {
    const language = languageOptions.find(lang => lang.value === lang_id);
    return language ? language.label : "Unknown Language"; // Default to "Unknown Language" if not found
  };

  const types = [
    {
      value: "Alpha",
      label: "Alpha Ads",
    },
    {
      value: "Classified",
      label: "Classified Ads",
    },
    {
      value: "Local",
      label: "Local Ads",
    },
    {
      value: "Inbound",
      label: "Inbound Ads",
    }
  ]

  const Headers = [
    { label: "Team", key: "team" },
    { label: "Targets", key: "dist" },
    { label: "Sales Person", key: "sales_person" },
    { label: "Start Date", key: "year" },
    { label: "Pac. Started Month", key: "package_started_month" },
    { label: "Pac New/Old", key: "package_new_old" },
    { label: "Pac. Campaign Name", key: "package_campaign_name" },
    { label: "Type Of Package", key: "package_type" },
    { label: "Pac. Amount", key: "package_amount" },
    { label: "Comp. Ads.", key: "completed_ads" },
    { label: "Comp. Amount", key: "completed_amount" },
    { label: "Bal. Ads.", key: "balance_ads" },
    { label: "Bal. Amount", key: "balance_amount" },
    { label: "Fil. Ads", key: "filter_campaign_count" },
    { label: "Fil. Amount", key: "filter_total_value" }
  ];

  const downloadPackageAdReport = () => {
    // if (!packageType.length) {
    //   Toast("error", "No data to Download");
    //   return;
    // }
    setDownloader(true);
    csvLinkRef?.current?.link?.click();
    setTimeout(() => {
      setDownloader(false);
    }, 3000);
  }
  const defaultValue = (options, selectedValues) => {
    if (Array.isArray(selectedValues)) {
      return options?.filter(option => selectedValues.includes(option?.value));
    } else {
      return options?.find(option => option.value === selectedValues) || null;
    }
  };
  
  
  const handleAdTypeChange = async(selectedOption) => {
    setweeks(null);
    let dept = selectedOption.map(option => option.value === 'Alpha' ? 5 :  option.value === 'Local' ? 2 :  option.value === 'Inbound' ? 9 : 'all')
    await getSales(dept)
    setsalesId(null)
    setpackageType(selectedOption)
  };
  const fetchPackageAdReport = async () => {
    setLoading(true)
    try {
      let res = await api({
        url: `/reports/packageAdReport`,
        method: "POST",
        responseType: "json",
        data: {
          packageType:packageType.length>0 ? packageType.map(option => option.value) : types.map(option => option.value),
          salesId,
          startTimestamp: dateRange.startDate,
          endTimestamp: dateRange.endDate,
          lang_id: +langfilter === -1 ? null : +langfilter,
          state_id: +statefilter === -1 ? null : +statefilter,
          district_ids: districtselect.length > 0 ? districtselect : [],
          weeks: weeks,
          package_new_old: package_new_old,
        }
      })
      if (res.code == 200)
        setpackagedata(res.data);

    } catch (err) {
      console.log(err);
    }
    finally{
      setLoading(false)
    }
  }
  const getSales = async (department_id =[]) => {
    try {
      let res = await api({
        url: "/user/sales_persons/getSalesByDepartment",
        method: "POST",
        responseType: "json",
        data: {
          dept:department_id,
        },
      });
      setsalesList(res.data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    let dept = packageType.map(option => option.value === 'Alpha' ? 5 :  option.value === 'Local' ? 2 :  option.value === 'Inbound' ? 9 : 'all')
    getSales(dept);
  }, []);
  useEffect(() => {
    fetchPackageAdReport();
  }, [packageType, salesId, dateRange, langfilter, statefilter, districtselect, weeks, package_new_old])

  const handleDateRange = (selectedDate) => {
    if (selectedDate) {
      if (selectedDate.startDate && selectedDate.endDate) {
        setDateRange(selectedDate);
      } else {
        setDateRange({ startDate: null, endDate: null });
      }
    } else {
      setDateRange({ startDate: null, endDate: null });
    }
  }


  const LanguageFilterChange = (e) => {
    setLangFilter(e.target.value);
    setDistrictfilter([]);
    setTarget_filter({
      lang_id: e.target.value,
      state_id: -1,
      district_id: -1,
      mandal_id: -1,
      village_id: -1,
    });
    if (parseInt(e.target.value) === -1) {
      setStatefilter(-1);
      setLangFilter(-1);
      setSelectdistrict([]);
    }
  };

  const StateFilterChange = async (value) => {
    setStatefilter(value);
    if (parseInt(value) !== -1) {
      try {
        let res = await api({
          url: "/location/getDistrictsByStateId",
          method: "POST",
          responseType: "json",
          data: { states: [value], langs: [langfilter] },
        });
        let districts = [];
        for await (let item of res.data) {
          const temp = { value: item, label: `${item.dist_name}` };
          districts.push(temp);
        }
        setDistrictfilter(districts);
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
    if (parseInt(value) === -1) {
      setSelectdistrict([]);
      setStatefilter(-1);
    }
  };


  const DistrictFilterChanger = async (selectedOptions) => {
    if (selectedOptions && selectedOptions.length > 0) {
      const values = selectedOptions.map(option => option.value);
      setSelectdistrict(values);
    } else {
      setSelectdistrict([]);
    }
  };

  const viewInternalDetails = async(order_id) => {
    try {
      if(internalDetails && internalDetails.order_id === order_id) {
        setInternalDetails(null);
        return;
      }
      const result = await api({
        url: "/reports/packageAdReportInternalDetails",
        method: "POST",
        responseType: "json",
        data: {
          order_id: order_id
        }
      });
      if (result.code === 200) {
        setInternalDetails({order_id, list: result.data || []});
      }
    } catch (error) {
      console.error(error);
    }
  }


  return (
    <div>
      <div className="flex space-x-4">
        <div className="w-64">
          <label className="block text-xs font-bold m-2">Package Type</label>
          <Select
            options={types}
            defaultValue={[{ value: "Alpha", label: "Alpha Ads" }]}
            onChange={handleAdTypeChange}
            isClearable
            isMulti
            placeholder="Select Ad Type"
            classNamePrefix="react-select"
          />
        </div>

        <div className="w-64">
          <label className="block text-xs font-bold m-2">SalesPersons</label>
          <Select
            aria-label="Default select example"
            placeholder="Sales Person"
            value={defaultValue(salesList, salesId)}
            onChange={(selected) => {
              if (!selected || selected.length === 0) {
                setsalesId(null);
              } else {
                setsalesId(selected.map((item) => item.value));
              }
            }}
            options={salesList}
            isMulti
            isClearable
          />
        </div>
        <div className="w-64">
          <label className="block text-xs font-bold m-2">Weeks</label>
          <Select
            aria-label="Default select example"
            placeholder="Weeks"
            value={defaultValue(
              [...LocalPricePackages, ...pricePackages],
              weeks
            )}
            onChange={(selected) => {
              if (!selected || selected.length === 0) {
                setweeks(null);
              } else {
                setweeks(selected.map((item) => item.value));
              }
            }}
            options={[...LocalPricePackages, ...pricePackages]}
            isMulti
            isClearable
          />
        </div>
        <div className="w-64">
          <label className="block text-xs font-bold m-2">New/Old</label>
          <Select
            aria-label="Default select example"
            placeholder="New/Old"
            value={defaultValue(packageNewOldOptions, package_new_old)}
            onChange={(selected) => {
              setpackage_new_old(selected ? selected.value : null);
            }}
            options={packageNewOldOptions}
            isClearable
          />
        </div>
        <div>
          <label className="block text-xs font-bold m-2">Date Range</label>
          <div className="border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66">
            <Datepicker
              classNames="form-input"
              value={dateRange}
              primaryColor={"cyan"}
              showShortcuts={true}
              useRange={true} // Allow date range selection
              configs={{
                shortcuts: {
                  today: "today",
                  yesterday: "yesterday",
                  currentMonth: "currentMonth",
                  pastMonth: "lastMonth",
                },
              }}
              onChange={handleDateRange}
            />
          </div>
        </div>
        <div className="w-64">
          <label className="block text-xs font-bold m-2">Language</label>
          <SlSelect
            placeholder="Select Language"
            name="lang"
            size="medium"
            onSlChange={LanguageFilterChange}
            value={langfilter}
          >
            <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
            {languageOptions.map((item) => {
              return (
                <SlOption key={item.value} value={item.value}>
                  {item.label}
                </SlOption>
              );
            })}
          </SlSelect>
        </div>
        {langfilter !== -1 && (
          <div className="w-64">
            <label className="block text-xs font-bold m-2">State</label>
            <SlSelect
              placeholder="Select State"
              name="state"
              size="medium"
              onSlChange={(e) => {
                StateFilterChange(e.target.value);
              }}
            >
              <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
              <SlOption value="-1">All</SlOption>
              {stateOptions
                .filter((item) => item.lang_id === +langfilter)
                .map((item) => {
                  return (
                    <SlOption key={item.state_id} value={item.state_id}>
                      {item.state_name}
                    </SlOption>
                  );
                })}
            </SlSelect>
          </div>
        )}

        {statefilter !== -1 && (
          <div className="w-64">
            <label className="block text-xs font-bold m-2">District</label>
            <Select
              placeholder="Select Districts"
              name="district"
              isMulti={true}
              isClearable={true}
              options={districtfilter.map((item) => ({
                value: item.value.dist_id,
                label: item.label,
              }))}
              onChange={DistrictFilterChanger}
              classNamePrefix="react-select"
            />
          </div>
        )}
        <div className="">
          <label className="block text-xs font-bold m-2">Download</label>
          <sl-tooltip content="Download" hoist>
            <sl-icon-button
              library="lucide"
              name="download"
              onClick={() => {
                downloadPackageAdReport();
              }}
              className="top-4 right-4"
            ></sl-icon-button>
          </sl-tooltip>
          <CSVLink
            data={[
              ...packagedata.map(
                ({
                  package_type,
                  district_id,
                  state_id,
                  lang_id,
                  sales_person,
                  order_name,
                  package_weeks,
                  order_value,
                  total_value,
                  campaign_count,
                  o_start_date,
                  is_old_pacakge,
                  filter_campaign_count,
                  filter_total_value,
                }) => {
                  return {
                    team: package_type,
                    dist:
                      district_id && district_id.length > 0
                        ? district_id[0]?.dist_name
                        : state_id && state_id.length > 0
                        ? state_id[0]?.state_name
                        : lang_id && lang_id.length > 0
                        ? getLanguageLabel(lang_id[0])
                        : "No Location",
                    sales_person,
                    year: formatDateDDMMYYY(o_start_date),
                    package_started_month: new Date(
                      o_start_date * 1000
                    ).toLocaleString("default", { month: "long" }),
                    package_new_old: is_old_pacakge ? "Old" : "New",
                    package_campaign_name: order_name,
                    package_type: package_weeks,
                    package_amount: order_value,
                    completed_ads: campaign_count,
                    completed_amount: total_value,
                    balance_ads: package_weeks - campaign_count,
                    balance_amount: order_value - total_value,
                    filter_campaign_count: filter_campaign_count,
                    filter_total_value: filter_total_value,
                  };
                }
              ),
              {
                team: "",
                dist: "",
                sales_person: "",
                // year: "",
                // package_started_month: "",
                package_campaign_name: "",
                package_type: "GrandTotal",
                package_amount: packagedata.reduce(
                  (sum, row) => sum + parseFloat(row?.order_value || 0),
                  0
                ),
                completed_ads: "",
                completed_amount: packagedata.reduce(
                  (sum, row) => sum + parseFloat(row?.total_value || 0),
                  0
                ),
                balance_ads: "",
                balance_amount: packagedata.reduce(
                  (sum, row) =>
                    sum + parseFloat(row?.order_value - row?.total_value || 0),
                  0
                ),
                filter_campaign_count: packagedata.reduce(
                  (sum, row) => sum + parseFloat(row?.filter_campaign_count || 0),
                  0
                ),
                filter_total_value: packagedata.reduce(
                  (sum, row) => sum + parseFloat(row?.filter_total_value || 0),
                  0
                ),
              },
            ]}
            headers={Headers}
            filename={`PackageAdReport.csv`}
            ref={csvLinkRef}
            style={{ display: "none" }}
          />
        </div>
      </div>

      <ScrollContainer>
        <table className="table table-bordered mt-4">
          <thead>
            <tr className="bg-gray-100">
              <th>S.No</th>
              <th>Team</th>
              <th>Targets</th>
              <th>Sales Person</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Pac. Started Month</th>
              <th>Pac New/Old</th>
              <th>Pac. Order Name</th>
              <th>Type Of Package</th>
              <th>Pac. Amount</th>
              <th>Comp. Ads.</th>
              <th>Comp. Amount</th>
              <th>Bal. Ads.</th>
              <th>Bal. Amount</th>
              <th>Fil. Ads</th>
              <th>Fil. Amount</th>
            </tr>
          </thead>

          {packagedata && packagedata.length > 0 ? (
            <tbody>
              {packagedata.map((row, idx) => (
                <>
                  <tr
                    key={idx}
                    className="border-t"
                    onClick={() => {
                      viewInternalDetails(row.order_id);
                    }}
                  >
                    <td>{idx + 1}</td>
                    <td>{row?.package_type}</td>
                    <td>
                      {row?.district_id && row.district_id.length > 0
                        ? row.district_id[0]?.dist_name
                        : row?.state_id && row.state_id.length > 0
                        ? row.state_id[0]?.state_name
                        : row?.lang_id && row.lang_id.length > 0
                        ? getLanguageLabel(row.lang_id[0])
                        : "No Location"}
                    </td>
                    <td>{row?.sales_person}</td>
                    <td>{formatDateDDMMYYY(row.o_start_date)}</td>
                    <td>{formatDateDDMMYYY(row.o_end_date)}</td>
                    <td>
                      {new Date(row?.o_start_date * 1000).toLocaleString(
                        "default",
                        { month: "long" }
                      )}
                    </td>
                    <td>{row?.is_old_pacakge ? "Old" : "New"}</td>
                    <td>{row?.order_name}</td>
                    <td>{row?.package_weeks}</td>
                    <td>{row?.order_value}</td>
                    <td>{row?.campaign_count}</td>
                    <td>{row?.total_value}</td>
                    <td
                      className={
                        row?.package_weeks - row?.campaign_count &&
                        row?.o_end_date <
                          Math.floor(new Date().getTime() / 1000)
                          ? "text-red-500"
                          : ""
                      }
                    >
                      {row?.package_weeks - row?.campaign_count}
                    </td>
                    <td>{row?.order_value - row?.total_value}</td>
                    <td>{row?.filter_campaign_count}</td>
                    <td>{row?.filter_total_value}</td>
                  </tr>
                  {internalDetails && internalDetails.order_id === row.order_id && (
                    <tr>
                      <td colSpan={17} className="p-4">
                        <div className="flex justify-center">
                          <div className="border rounded-xl shadow-sm bg-white p-4 w-[80%] relative">
                             <button
                                onClick={() => setInternalDetails([])}
                                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                              >
                                ✕
                              </button>
                            <h3 className="text-lg font-semibold mb-3 text-gray-700 text-center">
                              Campaign Details
                            </h3>

                            <table className="w-full border-collapse">
                              <thead>
                                <tr style={{ backgroundColor: "#dbeafe" }}>
                                  {" "}
                                  {/* Change theme here */}
                                  <th
                                    style={{
                                      padding: "8px",
                                      border: "1px solid #bfdbfe",
                                      textAlign: "left",
                                    }}
                                  >
                                    S.No
                                  </th>
                                  <th
                                    style={{
                                      padding: "8px",
                                      border: "1px solid #bfdbfe",
                                      textAlign: "left",
                                    }}
                                  >
                                    Campaign Name
                                  </th>
                                  <th
                                    style={{
                                      padding: "8px",
                                      border: "1px solid #bfdbfe",
                                      textAlign: "left",
                                    }}
                                  >
                                    Start Date
                                  </th>
                                  <th
                                    style={{
                                      padding: "8px",
                                      border: "1px solid #bfdbfe",
                                      textAlign: "left",
                                    }}
                                  >
                                    End Date
                                  </th>
                                  <th
                                    style={{
                                      padding: "8px",
                                      border: "1px solid #bfdbfe",
                                      textAlign: "left",
                                    }}
                                  >
                                    Amount
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {internalDetails.list.length > 0 ? (
                                  internalDetails.list.map((item, idx) => (
                                    <tr
                                      key={idx}
                                      style={{
                                        backgroundColor:
                                          idx % 2 === 0 ? "#ffffff" : "#eff6ff",
                                        transition: "0.2s",
                                      }}
                                    >
                                      <td
                                        style={{
                                          border: "1px solid #bfdbfe",
                                          padding: "8px",
                                        }}
                                      >
                                        {idx + 1}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #bfdbfe",
                                          padding: "8px",
                                        }}
                                      >
                                        {item.campaign_name}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #bfdbfe",
                                          padding: "8px",
                                        }}
                                      >
                                        {formatDateDDMMYYY(item.start_date)}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #bfdbfe",
                                          padding: "8px",
                                        }}
                                      >
                                        {formatDateDDMMYYY(item.end_date)}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #bfdbfe",
                                          padding: "8px",
                                        }}
                                      >
                                        {item.cpd}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      className="border p-3 text-center text-gray-500"
                                      colSpan={5}
                                    >
                                      No data found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </>
              ))}
              <tr className="bg-blue-100 font-bold text-lg">
                <td colSpan={10} className="text-center font-bold">
                  Grand Total
                </td>
                <td>
                  {packagedata.reduce(
                    (sum, row) => sum + parseFloat(row?.order_value || 0),
                    0
                  )}
                </td>
                <td>
                  {packagedata.reduce(
                    (sum, row) => sum + parseFloat(row?.campaign_count || 0),
                    0
                  )}
                </td>
                <td>
                  {packagedata.reduce(
                    (sum, row) => sum + parseFloat(row?.total_value || 0),
                    0
                  )}
                </td>
                <td>
                  {packagedata.reduce(
                    (sum, row) =>
                      sum +
                      parseFloat(row?.package_weeks - row?.campaign_count || 0),
                    0
                  )}
                </td>
                <td>
                  {packagedata.reduce(
                    (sum, row) =>
                      sum +
                      parseFloat(row?.order_value - row?.total_value || 0),
                    0
                  )}
                </td>
                <td>
                  {packagedata.reduce(
                    (sum, row) =>
                      sum + parseFloat(row?.filter_campaign_count || 0),
                    0
                  )}
                </td>
                <td>
                  {packagedata.reduce(
                    (sum, row) =>
                      sum + parseFloat(row?.filter_total_value || 0),
                    0
                  )}
                </td>
              </tr>
            </tbody>
          ) : !packagedata?.length && !loading ? (
            <NoDataFound colspan="13" />
          ) : (
            <TableSkelton colspan="13" />
          )}
        </table>
      </ScrollContainer>
    </div>
  );
}
export default PackageAdReport;